import { Familiar } from '@/components/Familiar'

// The ✦ Familiar as a full page — the chat posture, phone-first. Same component the
// desktop rail hosts; here it gets the whole screen.
export function FamiliarPage() {
  return (
    <div className="dw-page-narrow dw-familiar-page">
      <Familiar />
    </div>
  )
}
